<template>
    <transition name="fade">
      <div class="notification-popup" v-if="visible">
        <!-- <i class="icon"></i> -->
        <span class="message">{{ message }}</span>
      </div>
    </transition>
  </template>
  
  <script>

import { defineComponent } from "@vue/runtime-core";
export default defineComponent({
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      message: {
        type: String,
        default: '',
      },
    },
  });
  </script>
  
  <style scoped>
.notification-popup {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 15px 20px;
  background-color: #21BA45;
  color: #fff;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  max-width: 80%;
  text-align: center;
}

.icon {
  margin-right: 10px;
  color: #fff;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
  
  
  .icon {
    margin-right: 10px;
  }
  
  .slide-enter-active,
  .slide-leave-active {
    transition: all 0.5s;
  }
  
  .slide-enter,
  .slide-leave-to {
    transform: translateY(100%);
  }
  </style>
  